import axios from "axios";

const setJwt = (jwt, logout) => {
	axios.defaults.headers.common.Authorization = `Bearer ${jwt}`;

	if (axios.interceptors.response.length > 0) {
		return;
	}

	axios.interceptors.response.use((response) => {
		if (response && response.status === 401) {
			logout();
		}

		return response;
	}, (error) => {
		if (error && error.response && error.response.status === 401) {
			logout();
			return Promise.resolve();
		}

		return Promise.reject(error);
	});
};

const app = () => axios.get("/api/app");
const appLists = () => axios.get("/api/applists");
const samples = () => axios.get("/api/samplefiles");
const queue = () => axios.get("/api/queue");
const dequeue = () => axios.delete("/api/queue");
const analysisRequests = r => axios.post("/api/analysisrequests", r);
const testGenerate = r => axios.post("/api/testgenerate", r);
const testGenerateStatus = () => axios.get("/api/testgenerate");
const testGenerateCancel = () => axios.delete("/api/testgenerate");
const transactionRequest = r => axios.get(`/api/transactionrequest/${r}`);
const transaction = id => axios.get(`/api/transactions/${id}`);
const transactions = r => axios.post("/api/transactions", r);
const cloneCheck = id => axios.get(`/api/dbsync/${id}`);
const syncCheck = () => axios.get("/api/dbsync");
const fileDownload = (id, type) => `/api/transactionfile/${id}/${type}`;
const token = id => axios.get(`/api/token/${id}`);
const requestStatus = id => axios.get(`/api/requeststatus/${id}`);
const status = r => axios.post("/api/status", r);
const jwtCheck = jwt => axios.get("/api/jwtcheck", {
	headers: { Authorization: `Bearer ${jwt}` },
});
const dailyCounts = r => axios.post("/api/dailycounts", r);
const hourlyCounts = r => axios.post("/api/hourlycounts", r);
const report = r => axios.post("/api/report", r);
const reportExcel = r => `/api/report?start=${r.start}&end=${r.end}&offset=${r.offset}`;
const workersStatus = () => axios.get("/api/workersstatus");
const workerAction = r => axios.post("/api/workeraction", r);
const snapshotData = id => axios.get(`/api/snapshotdata/${id}`);
const system = () => axios.get("/api/system");
const systemChange = r => axios.post("/api/system", r);

export default {
	setJwt,
	app,
	appLists,
	samples,
	queue,
	dequeue,
	transactionRequest,
	analysisRequests,	// NOT USED
	transaction,
	transactions,
	cloneCheck,
	syncCheck,
	fileDownload,
	token,
	requestStatus,
	testGenerate,
	testGenerateStatus,
	testGenerateCancel,
	status,
	jwtCheck,
	dailyCounts,
	hourlyCounts,
	report,
	reportExcel,
	workersStatus,
	workerAction,
	snapshotData,
	system,
	systemChange,
};
